import Link from 'next/link'
import React from 'react'
import { Right2Icon } from '@components/icons/Right2Icon'

function FaqMenu({ title, url }: { title: string; url: string }) {
  return (
    <Link href={url} prefetch={false}>
      <a
        key={title}
        className='flex items-center justify-between last:border-none last:mb-0 border-b border-gray-3 mb-[20px] pb-[20px] hover:text-primary dark:hover:text-primary cursor-pointer dark:text-white-2 dark:border-dark-1'
      >
        <span>{title}</span>
        <Right2Icon width='14' height='14' />
      </a>
    </Link>
  )
}

export default FaqMenu
